import "cross-fetch/polyfill";
import styled from "styled-components";
import { useStats } from "react-instantsearch";
import Box from "../../components/elements/v2/Box/Box";
import React from "react";
import { breakpoints } from "../styledHelpers";

function Stats(props: any) {
  const { nbSortedHits, nbHits, query } = useStats();

  // Use nbSortedHits if available (the index is a virtual replica), otherwise fallback to nbHits
  // See https://www.algolia.com/doc/guides/managing-results/refine-results/sorting/in-depth/relevant-sort/#enabling-relevant-sorting-reduces-the-number-of-results
  const hitCount = nbSortedHits || nbHits;

  return (
    <Box {...props}>
      {hitCount}{" "}
      {query ? (
        <>
          {'results for "'}
          <b>{query}</b>
          {'"'}
        </>
      ) : (
        "items"
      )}
    </Box>
  );
}

export const SearchSummary = styled(Stats)`
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-size: 0.875em;
`;

export const MobileOnlySearchSummary = styled(Stats)`
  display: flex;
  align-items: center;
  white-space: nowrap;

  ${breakpoints.up("tablet")} {
    display: none;
  }
`;
